import {Component, Inject, Input, OnInit} from '@angular/core';
import { CaseService } from '@app/ps/services/case.service';
import { StateService } from '@uirouter/angular';
import { CaseStatusService } from '@app/ps/services/case-status.service';
import { Restangular } from 'ngx-restangular';
import { CaseModel } from "@app/ps/models/case.model";
import * as _ from 'lodash';
import { SwitchOption } from '@app/common/components/switch/switch.component';
import { APP_BRAND } from '@app/common/services/config.service';
import { DialogService } from '@app/common/services/dialog.service';

@Component({
  selector: 'expropriation-enforceable',
  templateUrl: './expropriation-enforceable.component.html',
  styleUrls: ['./expropriation-enforceable.component.scss']
})
export class ExpropriationEnforceableComponent implements OnInit {

  @Input() caseId: number;
  loading = true;
  data: CaseModel;
  statusData = {
    expropriationEnforceableDate: this.APP_BRAND.NAME === 'RSD' ? null : new Date(),
    contractRegisterPublication: null,
    contractRegisterPublicationDate: null,
    contractRegisterPublicationContractId: null,
    contractRegisterPublicationVersionId: null
  };
  subjectsData = {
    dataCaseOwnerships: null,
    caseOwnerships: null,
    caseSubjects: null,
  };
  name: string;
  existsAcquisitionDeed = false;

  contractRegisterPublicationOptions: SwitchOption[] = [
    { id: 'N', value: 'Bez zveřejnění' },
    { id: 'Y', value: 'Zveřejnit' },
    { id: 'O', value: 'Zveřejněno druhou stranou' },
  ];

  constructor(
    private caseService: CaseService,
    private stateService: StateService,
    private restangular: Restangular,
    private caseStatusService: CaseStatusService,
    private dialogService: DialogService,
    @Inject(APP_BRAND) private APP_BRAND: any,
  ) {
    this.onConfirm = this.onConfirm.bind(this);
    this.isSubjectSigned = this.isSubjectSigned.bind(this);
    this.isStatusValid = this.isStatusValid.bind(this);
    this.onDateCheck = this.onDateCheck.bind(this);
  }

  async ngOnInit() {
    this.name = (await this.caseStatusService.loadStatusName('ExpropriationEnforceable')).name;
    this.data = await this.restangular.one('cases', this.caseId).get({loadCollections: ['caseSubjects', 'caseOwnerships']}).toPromise();

    if (this.APP_BRAND.NAME === 'RSD') {
      this.existsAcquisitionDeed = await this.caseService.existsAcquisitionDeed(this.caseId);
    }

    // subjects part
    this.subjectsData.caseOwnerships = _.cloneDeep(this.data.caseOwnerships);
    this.subjectsData.caseSubjects = _.cloneDeep(this.data.caseSubjects);
    this.subjectsData.dataCaseOwnerships = this.caseService.getDataCaseOwnershipsUnique(this.subjectsData.caseOwnerships, this.subjectsData.caseSubjects);

    this.loading = false;
    this.onDateCheck();
  }

  async onConfirm(): Promise<any> {
    this.caseService.fillCaseOwnershipsByMain(this.subjectsData.dataCaseOwnerships, this.subjectsData.caseOwnerships);

    await this.restangular
      .one('cases', this.caseId)
      .all('ownerships-subjects')
      .customPUT({
        caseOwnerships: this.subjectsData.caseOwnerships,
        caseSubjects: this.subjectsData.caseSubjects,
      })
      .toPromise();

    if (this.statusData.contractRegisterPublication !== 'O') {
      this.statusData.contractRegisterPublicationDate = undefined;
      this.statusData.contractRegisterPublicationContractId = undefined;
      this.statusData.contractRegisterPublicationVersionId = undefined;
    }

    await this.restangular.one('cases', this.caseId).customPUT(this.statusData, 'expropriation-enforceable').toPromise();

    this.stateService.go('^');
  }

  isSubjectSigned() {
    return true;
  }

  isFulfillmentPriceValid(): boolean {
    let price = 0;

    for (const caseOwnership of this.subjectsData.dataCaseOwnerships) {
      if (caseOwnership.ownership.isBsm && caseOwnership.singlePayment) {
        price += caseOwnership.caseSubjects[0].fulfillmentPriceSjm || 0;
      } else {
        for (const caseSubject of caseOwnership.caseSubjects) {
          price += (caseOwnership.ownership.isBsm ? caseSubject.fulfillmentPriceSjm : caseSubject.fulfillmentPrice) || 0;
        }
      }
    }

    return price === this.data.fulfillmentPrice;
  }

  isSubjectsValid() {
    if (this.APP_BRAND.NAME !== 'RSD') {
      return true;
    }

    for (const caseOwnership of this.subjectsData.dataCaseOwnerships) {
      if (caseOwnership.errors && caseOwnership.errors.length) {
        return false;
      }
      for (const caseSubject of caseOwnership.caseSubjects) {
        if (caseOwnership.requirements && caseOwnership.requirements.length) {
          return false;
        }
      }
    }

    return !!this.statusData.contractRegisterPublication
      && (this.statusData.contractRegisterPublication !== 'O'
        || (this.statusData.contractRegisterPublicationDate && this.statusData.contractRegisterPublicationContractId && this.statusData.contractRegisterPublicationVersionId)
      );
  }

  isStatusValid() {
    return this.statusData.expropriationEnforceableDate && !this.aquisionDeedNeeded();
  }

  onDateCheck(signedDate?: string) {
    if (this.aquisionDeedNeeded()) {
      this.caseService.acquisitionDeedNeeded(this.caseId);

      const msg = `Datum nabytí právní moci nelze vložit. V dokumentech k případu chybí nabývací listina. Nedojde ke změně stavu případu.`;
      this.dialogService.alertDialogPromise(msg)
        .then(() => {
          this.data.expropriationEnforceableDate = undefined;
        });
    }
  }

  aquisionDeedNeeded() {
    if (this.APP_BRAND.NAME !== 'RSD') {
      return false;
    }
    return !this.existsAcquisitionDeed;
  }
}
